import { useMutation } from '@tanstack/react-query';
import { deleteFunctionRequest } from '../requests/deleteFunctionRequest';
import { queryClient } from '../../../app/App';
import { Alert } from '../../../components/Alert';
import { AxiosError } from 'axios';

export function useDeleteFunction() {
	const deleteFunction = useMutation({
		mutationFn: async (id: number) => {
			return deleteFunctionRequest(id);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully deleted!', type: 'success' });
			queryClient.invalidateQueries(['RESPONSIBILITY_LIST']);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return {
		deleteFunction,
	};
}
